import Services from "./index.service";
const { OshimedBackend } = Services;



const sendWelcomeEmail = async (email) =>  {
try {
    const response = await OshimedBackend.post('email/send-welcome-email', {email});
    return response.data;
} catch (error) {
    throw handleError(error, 988733)
}
}

const resendICF = async ({ email, firstname, lastname, participant_id, site_icf_id, consent_id }) => {
  try {
    const response = await OshimedBackend.post("email/resend-icf", {
      email,
      firstname,
      lastname,
      participant_id,
      site_icf_id,
      consent_id,
    });
    return response.data;
  } catch (error) {
    throw handleError(error, 988734);
  }
};

export default {
    sendWelcomeEmail, 
    resendICF,
};